import { Linking } from '@types';
import { convertDateAndTimeToDisplayFormat, toSentenceCase } from '@utils';

import styles from './linkingItem.module.scss';

export interface LinkingItemProps {
	linking: Linking;
}

export const LinkingItem = ({ linking }: LinkingItemProps) => {
	const { title, dateSubmitted, reference, status } = linking;
	return (
		<tr className={styles.container} role="row">
			<td role="rowheader">{title}</td>
			<td>{convertDateAndTimeToDisplayFormat(dateSubmitted)}</td>
			<td>{reference}</td>
			<td>{toSentenceCase(status)}</td>
		</tr>
	);
};
